import { useCallback, useState } from "react"

import { updatePlan } from "data/fetch/plans/single"
import logger from "shared/services/logger"

const useUpdatePlan = userId => {
  const [loading, setLoading] = useState(false)

  const updateUserPlan = useCallback(
    async reqData => {
      try {
        setLoading(true)
        const { data } = await updatePlan(userId, reqData)
        return data
      } catch (error) {
        logger(
          "Failed Rate Plan change",
          userId,
          "GTM:Change Plan",
          "error",
          error.response?.data?.error?.description || error
        )
        setLoading(false)
        return null
      } finally {
        setTimeout(() => {
          setLoading(false)
        }, 18000)
      }
    },
    [userId]
  )

  return {
    loading,
    updateUserPlan,
  }
}

export default useUpdatePlan
